module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fm_head"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063009493_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "rtitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063009493_Titlepage#title"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063009493_Dedication#_idParaDest-1"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "con1",
    attrs: {
      "id": "r_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_1#_idParaDest-3"
    }
  }, [_vm._v("1: The Secret")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_2#_idParaDest-5"
    }
  }, [_vm._v("2: Restarting")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_3#_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: Don’t Make a Fuss")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_4#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: Wearing Someone Else’s Face")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_5#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: My Lot")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_6#_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: City Is a Pity")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_7#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Did You Lose Your Comb?")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_8#_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Shame")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_9#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Time Traveling")])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Chapter_10#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: Passing")])]), _vm._v(" "), _c('p', {
    staticClass: "con1",
    attrs: {
      "id": "r_idParaDest-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Acknowledgments#_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Notes#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780063009493_Copyright#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "con",
    attrs: {
      "id": "r_idParaDest-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ece8de4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780063009493_Contents.vue
// module id = 66
// module chunks = 0